import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { Editor } from 'ngx-editor';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';



@Component({
  selector: 'app-elcm-create-email-templet',
  templateUrl: './elcm-create-email-templet.component.html',
  styleUrls: ['./elcm-create-email-templet.component.scss'],

})
export class ElcmCreateEmailTempletComponent implements OnInit {

  editor!: Editor;
  htmlContent = new FormControl('');

  @ViewChild('applicationFormLink') applicationFormLink: ElementRef | undefined;
  invitationEmailSubject: any;
  isPublished: boolean = false;
  buttonColorName: any
  PopupName: any
  green = '#05ca05';
  employeeApplicationEmailBody: any = null;
  offerlaterEmailBody: any = null;
  public Editor = ClassicEditor;

  text: string = '<p>Hello, this is default text in editor!</p>'; // ✅ Default text



  editorContent: string = '<p>Welcome to Jodit Editor!</p>';
  submissionEmailBody: any = null;
  appoinmentlaterEmailBody: any = null;
  textControl = new FormControl('<p>Hello, this is default text in editor!</p>'); // ✅ Use FormControl
  isEditing = false;
  editorConfig: any = {
    height: 500,
    toolbarSticky: false,
    toolbarAdaptive: false,

    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'link', 'image', '|',
      'undo', 'redo', '|',
      'fontsize'
    ],
  };

  createSurveyForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserRole: any;
  selectedYear: any;
  popupName: any;
  emplyeeName: any = "#EMPLOYEE_NAME#"
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private toastController: ToastController,
    public sharedService: SharedService, public dialogRef: MatDialogRef<ElcmCreateEmailTempletComponent>,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe, public dialog: MatDialog,
    private renderer: Renderer2, private el: ElementRef
  ) {

    this.popupName = data.popupName;
    console.log(this.popupName);

  }
  editorForm = new FormGroup({
    editor: new FormControl('<p>Default content</p>')
  });
  ngOnInit() {



    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.getMailBodyData();
    this.getletterContent();
    setTimeout(() => {
      this.mailTemplateSave();
    }, 300)
    this.editor = new Editor();
  }
  employeeApplicationEmailBodyFromBAckend: any;
  allemailtempalteData: any = [];
  getMailBodyData() {
    this.httpService.callGetService(`${this.config.emailtempletGetData}`).subscribe((record: any) => {

      this.allemailtempalteData = record.data;
      console.log(this.allemailtempalteData);

    })


  }
  toggleEditMode() {
    this.isEditing = !this.isEditing;
    // this.editorConfig = { ...this.editorConfig, readonly: !this.isEditing }; // Toggle readonly mode
  }
  subjectClick: any = '';
  subjectclick(event: any) {
    this.subjectClick = event

  }
  addToEditor(textToAdd: string) {
    const editor = document.getElementById('htmlDiv');
    if (!editor) return;
    console.log(this.subjectClick);

    if (this.subjectClick === 'subject' || this.subjectClick === '') {
      return;
    } {

      document.execCommand(
        'insertHTML',
        false,
        //     `<span class="protected-text" data-protected contenteditable="false">
        //      <b>${textToAdd}</b>
        //  </span>`
        `<span>
    <b>${textToAdd}</b>
</span>`
      );
    }
  }






  @HostListener('keydown', ['$event'])
  preventBackspace(event: KeyboardEvent) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    const currentNode = range.startContainer.parentElement;
    if (!currentNode) return;

    // Prevent deletion when cursor is directly inside the protected text
    if (currentNode.classList.contains('protected-text') &&
      (event.key === 'Backspace' || event.key === 'Delete')) {
      event.preventDefault();
      return;
    }

    // Check if user tries to delete a protected text span
    const previousNode = range.startContainer.previousSibling as HTMLElement;
    const nextNode = range.startContainer.nextSibling as HTMLElement;

    if ((previousNode && previousNode.classList?.contains('protected-text')) ||
      (nextNode && nextNode.classList?.contains('protected-text'))) {
      // event.preventDefault();
    }
  }








  employeeApplicationEmailBodyFromBAckendfrontEndEmail:any
  mailTemplateSave() {
    if (this.popupName == 'Create Email Body for Employment application') {

      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'ELCM_EMPLOYEE_APPLICATION');
      console.log(emailbody);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      console.log(emailbody);


      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
        // this.employeeApplicationEmailBody = emailbodytemlate.replace(
        //  /#EMPLOYEE_NAME#/g,  // Match single placeholder
        //   `<span id="empName" readonly contenteditable="false" style=" padding: 2px; border-radius: 4px;">
        //     <b>#EMPLOYEE_NAME#</b>
        //   </span>`
        // );


      }

      else {
        this.employeeApplicationEmailBodyFromBAckendfrontEndEmail='ELCM_EMPLOYEE_APPLICATION';
        this.invitationEmailSubject = "#EMPLOYEE_NAME# - Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
        Dear <b>#CANDIDATE_NAME#</b>, 
        <br /><br />
        Further to our discussions with you, we are delighted to start the process of offer and onboarding. Hence, we request you to click on the 
        <a id="applicationFormLink" target="_blank"><b>employment application form</b></a>
        link, fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.
        <br /><br />
      
      
        Best regards, 
        <br />
        <b>#HR_TEAM_NAME#</b>
        <br />Human Resources Team
      `;
      }
    } else if (this.popupName == 'Create Email Body for Intimation email') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Intimation email from candidate');
      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
      I.Candidate name have submitted the employment application form with supportings. All information provided by me is <br>
      accurate.
      `;

      }
    } else if (this.popupName == 'Create Email Body for offer letter email') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Offer letter');
      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        // this.invitationEmailSubject = emailbody[0]?.subject;
        this.invitationEmailSubject = emailbody[0].subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
      We are pleased to extend an offer to you dated You are requested to confirm acceptance to the same..
      `;
      }
    }
    else if (this.popupName == 'Create Email Body for Appoinment letter issuance') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'Appointment Latter');
      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
       \nDear <b>#CANDIDATE_NAME#</b>, 
       We are delighted that you have joined us and we are pleased to issue an appointment
        letter to you as enclosed as an attachment. Please sign a copy of it and return it by email/ hard copy for our records"
      `;
      }
    }
    else if (this.popupName == 'Confirmation letter mail with no change') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'CONFIRMATION_LETTER_WITHOUT_CHANGES_ELCM');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0].subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = "- Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
     Dear #EMPLOYEE_NAME#,
     <br><br>Further to our discussions with you, we are delighted to start the process of offer
      and onboarding. Hence, we request you to click on the employment application form link, 
     fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.<br><br>"

      `;
      }
    }
    else if (this.popupName == 'confirmation with change') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'CONFIRMATION_LETTER_WITH_CHANGES_ELCM');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        // this.invitationEmailSubject = emailbody[0]?.subject;
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
   Dear #EMPLOYEE_NAME#,<br><br>Further to our discussions with you, 
   we are delighted to start the process of offer and onboarding. Hence, 
   we request you to click on the employment application form link, 
   fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.<br><br>
      `;
      }
    }
    else if (this.popupName == 'Extention of probation letter mail') {
      let emailbody = this.allemailtempalteData.filter((elm: any) => elm.name == 'EXTENTION_PROBATION_LETTER_ECLM');
      console.log(this.allemailtempalteData);

      this.employeeApplicationEmailBodyFromBAckend = emailbody;
      let emailbodytemlate = emailbody[0]?.body;
      if (emailbody.length > 0) {
        this.invitationEmailSubject = emailbody[0]?.subject.replace('#EMPLOYEE_NAME#', '').trim();
        this.employeeApplicationEmailBody = emailbodytemlate;
      } else {
        this.invitationEmailSubject = " - Welcome to CATALYST! .";
        this.employeeApplicationEmailBody = `
   Dear #EMPLOYEE_NAME#,<br><br>Further to our discussions with you, we are delighted to 
   start the process of offer and onboarding. Hence, we request you to click on the employment application 
   form link, fill it out, and submit it to us immediately along with all the necessary supporting documents as requested.<br><br>
      `;
      }
    }

  }
  decodeHtml(html: string): string {
    let txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value.replace(/&#10;/g, '\n'); // Convert line breaks properly
  }



  letterContentsubject: any;
  letterContentBody: string = ''; // Initialize with an empty string or some default text
  letterContentBodyReadonly: string = '';
  employeeApplicationcontentBodyFromBackend: any
  employeeApplicationcontentBodyFromFrontEnd: any
  getletterContent() {
    this.httpService.callGetService(`${this.config.getAllLatterFORELCM}?companyId=${this.loggedInUserCompanyID}`).subscribe((record: any) => {
      console.log(record);

      if (this.popupName == 'Create offer letter content') {

        let contentbody = record.data.filter((elm: any) => elm.name == 'Offer Latter' ||elm.name == 'Offer Letter');
        // let contentbody: any = []
        console.log(contentbody);

        this.employeeApplicationcontentBodyFromBackend = contentbody;
        let contentbodytemlate = contentbody[0]?.content;
        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
          // this.letterContentBody = contentbodytemlate;


          let decodedContent = this.decodeHtml(contentbodytemlate);
          this.letterContentBody = decodedContent.replace(/\n/g, '<br>');

        } else {

          this.employeeApplicationcontentBodyFromFrontEnd = "Offer Letter"
          this.letterContentsubject = "#EMPLOYEE_NAME# Offer Letter .";
          this.letterContentBody = `
Ref.: SIL/HR/04\n 
Date: #Date#\n  

To: Mr.#EMPLOYEE_NAME# \n 
#Address#\n  

Sub: LETTER OF INTENT\n 

Dear #EMPLOYEE_NAME# ,\n 

We are pleased to extend an offer for the position of #Designation# in the Department #Department#, Band #Band#, based on your application and subsequent interview. Your initial posting will be at#COMPANY_NAME#, #workLocationCity# .\n 

Please note that this position is subject to transfer to any of the Company’s plants or offices, or those of its affiliates, as required.\n 

You are advised to join us on or before #Date_Of_Joining#. Failure to do so may result in cancellation of this offer unless a written extension has been granted.\n 

Documents Required for Joining:Please bring the original documents and a set of photocopies of the following items at the time of joining:\n 

Educational testimonials (from 10th grade onwards).\n   Mandatory identity documents (Aadhar Card, PAN Card, Driving License, Ration Card, Passport, etc.).\n   Four passport-sized photographs.\n   Pre-employment medical fitness certificate.\n   

Documents from your current employer, including:\n 

Resignation letter (to be submitted within one week of receiving this offer letter).\n 

Detailed appointment letter.\n  
  Relieving letter.\n  
  Experience letter.\n  
  Latest increment letter.\n 
  Latest three months’ pay slips along with the corresponding bank statements.\n  
  A cancelled bank cheque.\n   
  
  Terms and Conditions:Detailed terms and conditions governing your appointment will be provided at the time of joining.\n  
  
  Acceptance:I have read and fully understand the terms and conditions of this offer letter.
   I acknowledge that any incorrect information provided by me may lead to cancellation of this LOI and subsequent release of the appointment letter.
   I accept the above offer and confirm that I will report for duty on or before #Date_Of_Joining#.\n 
  
  Sincerely,\n 
        
  For Sellowrap Industries Limited\n 
  
  Authorised Signatory\n   
      
  Date: #Date#\n
`.replace(/\n/g, '<br>');


        }
      } else if (this.popupName == 'Create Appoinment letter content') {

        let contentbody = record.data.filter((elm: any) => elm.name == 'Appointment Letter');
       
        console.log(contentbody);

        this.employeeApplicationcontentBodyFromBackend = contentbody;
        let contentbodytemlate = contentbody[0]?.content;
        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
          // this.letterContentBody = contentbodytemlate;
          let decodedContent = this.decodeHtml(contentbodytemlate);
          this.letterContentBody = decodedContent.replace(/\n/g, '<br>');

        } else {

          this.employeeApplicationcontentBodyFromFrontEnd = "Appointment Letter"
          this.letterContentsubject = "#EMPLOYEE_NAME# Appointment Letter";
          this.letterContentBody = `
                                                                       Ref.: SIL/HR/04\n
                                                                       Date: #Date#\n
          To, \n
          Ms. #EMPLOYEE_NAME#,\n
          
          #Address#\n

          Subject: Letter of Appointment\n

          Dear #EMPLOYEE_NAME#,\n

          With reference to your application & subsequent interview with us, we are pleased to offer you employment in our organization on the following terms and conditions:\n\n
          1. Effective Date of Appointment: #Date#\n
          2. Designation: #Designation#\n
          3. Initial Place of Work: #WorkLocationState#\n
          4. Band: #Band#\n\n
          01. Personal Particulars:\n
          You will keep us informed of any change in your residential address, your family status, or any other relevant particulars. You would also let us know the name and address of your legal heir/nominee from time to time if it changes or alters.\n\n
          02. Remuneration:\n
          Your remuneration will be set out in Annexure A hereto subject to deduction of tax at source as applicable. Other allowances like HRA and Conveyance Allowance, etc., will be paid as per the prevailing norms of the Company (as per Annexure – A). In addition, you will be reimbursed for all official expenses incurred as per company policy and your band mentioned in the Organization HR Manual. Your remuneration/performance will be reviewed every year, and the increment will be granted based on your satisfactory performance. Your salary structure is subject to changes made by the Company in its overall salary structure, from time to time.\n\n
          03. Training & Development:\n
          You may be required to undergo training with any associate or subsidiary of the Company whether in India or abroad, subject to the execution of a Training Agreement with the Company. Non-compliance with the above may attract disciplinary action, including termination of your services with the Company.\n\n
          04. Nature of Work:\n
          Your nature of work mainly includes all aspects of the duties and responsibilities of your departmental functions decided by your supervisor, as well as any other ad-hoc duties assigned to you from time to time. You will work at a high standard of initiative, efficiency, and economy in the organization. The nature of work and responsibilities will be assigned and explained to your senior from time to time.\n\n
          05. Probation, Confirmation & Termination of Employment:\n
          You will be on probation for a period of six months. This period may be extended at the discretion of the Company. During the probation period, your contract of employment is terminable by either party without giving any reason, with 15 days' notice. Any short notice will be in lieu of gross salary for the remaining period of 15 days.\n
          Notwithstanding the above, during the probation period, your services may be terminated by the Company on account of the following reasons without any notice or payment:\n
          a) Management is not satisfied with your performance;\n
          b) Any misconduct on your part;\n
          c) Furnishing of false information about yourself or your educational qualifications or experience;\n
          d) Any other reason justifiable in the interest of the Company;\n
          e) If you remain absent for a continuous period of 7 (seven) days without notice to the Company.\n
          If you are found suitable for the appointed post, you will be confirmed at the end of the probation period. Unless you are confirmed in writing at the end of the probation period or any extension thereof, your services with the Company shall automatically stand terminated without any notice by the Company.\n
          After confirmation, this contract of employment may be terminated by either party without assigning any reason by giving two months' notice or gross salary in lieu of the short notice period. The Company also reserves the right to relieve you even before the expiry of the period of notice given by you.\n\n
          06. Provident Fund and Gratuity:\n
          You will be entitled to receive PF and Gratuity as per applicable legal provisions and Company policy in force from time to time.\n\n
          07. Leaves:\n
          You will be entitled to leaves (Casual/Sick/Earned) as per applicable legal provisions and company policy in force from time to time.\n\n
          08. Retirement Age:\n
          The normal age of retirement is 60 years. However, at the discretion of the Management, an employee may be prematurely retired any time after they attain 55 years.\n\n
          09. Resignation:\n
          On acceptance of your resignation letter by the Company, you shall hand over to the Company before you are relieved, all correspondences, specifications, formulas, books, documents, market data, business data, literature, drawings, CDs, floppies, and/or any other property of the Company. You shall not make or retain any copies of the above papers/information.\n\n
          10. Transfer:\n
          You may be required to work for any associate or subsidiary of the Company on either a full-time or part-time basis in any part of India or abroad, or as directed by the Management. Non-compliance with such transfer orders may attract disciplinary action, including termination of services.\n\n
          11. Intellectual Property Rights:\n
          If, during the period of your employment with us, you achieve any invention, process improvement, operational improvement, or other process/method likely to result in more efficient operation of any of the activity of the company, the company shall be entitled to use, utilize, and exploit such an improvement, and you shall assign all rights thereof to the company for the purpose of seeking any patent rights or for any other purpose. The company shall have sole ownership rights of all the intellectual property rights that you may create during the tenure of your association with the company, including but not limited to the creative concept that you may develop during your association with the company.\n\n
          12. Code of Conduct:\n
          You will continuously endeavor to achieve excellence in all behavioral norms pertaining to discipline, self-control, professionalism, and best practices, and you will abide by the 'Code of Conduct' applicable to the employees of the Company. In the event of any misconduct, as mentioned in the Company’s Code of Conduct, the Company reserves the right to take appropriate disciplinary action as it may deem fit.\n
          You will be required to comply with the confidentiality policy of the Company and accordingly keep all information which has been acquired by you out of training imparted or arranged by the Company or techniques/know-how made available to you by the Company, secret and confidential.\n
          During the period of your employment, you shall not disclose to any unauthorized person, by word of mouth or otherwise, particulars or details of the Company’s manufacturing processes, technical know-how, security arrangement, administrative and/or organizational matters of a confidential/secret nature, which you have come to know by virtue of your being the Company’s employee.\n
          This covenant shall endure during your employment with the Company and for a period of 2 (two) years from the cessation of your employment with the Company, irrespective of the reasons for your cessation.\n
          You undertake that when you leave or cease to be an employee of this Company for any reason whatsoever, you shall not join or associate, directly or indirectly, in any capacity or provide any kind of assistance, guidance, consultancy, or service, with or without honorarium, for a period of two years in any Company or Organization which deals with any product or provides services similar to our Company.\n\n
          13. Working Hrs. & Administrative Rules:\n
          You need to work as per the shifts (timing) assigned to you as per the company policy. In addition, you are required to work extra hours as and when required and informed by your senior. You shall be required to abide by the administrative instructions, rules, and regulations as in force from time to time for the effective and smooth working of the organization.\n
          You will observe working hours and holidays as applicable to your location and place of work.\n\n
          14. Conflict of Interest:\n
          You will be required to disclose to the Company forthwith any discovery, invention, process, or improvement made or discovered by you while in the Company’s service. Such discovery, invention, process, or improvement shall belong absolutely to and be the sole property of the Company.\n
          You shall devote your entire time and attention exclusively to the duties entrusted to you, and you will not engage yourself in any other direct/indirect business or work, profession, or employment, either honorary or otherwise, in any capacity, except with the written permission of the Company. Contravention of this will lead to the termination of your service without any notice or any compensation in lieu of such notice.\n
          You will not seek membership of any local or public body without first obtaining written permission from the Management.\n
          You shall ensure that you shall not directly or indirectly engage yourself in such activity or have any interest in or perform any services for any person who is involved in such activity, which is or shall be in conflict with the interest of the Company.\n\n
          15. Standing Orders:\n
          You will abide by the Standing Orders, rules & regulations, company policies, and service conditions that may be in force or application to the organization or are framed from time to time by the company.\n
          You will be governed by the terms & conditions of this letter and the Company's rules and regulations as applicable, enforced, amended, or altered from time to time, and the company’s decision shall be final.\n\n
          16. Jurisdiction:\n
          In the event of any dispute arising under, in connection with, incidental to, and/or interpretation or scope of this agreement, the same shall be referred and resolved in the Courts at Gurugram, Haryana.\n\n
          17. We trust that you have not provided us with any false declaration or willfully suppressed any material information. Otherwise, you will be liable for removal from service without notice.\n
          You are also required to inform us if there are any agreements, oral or written, which you have entered into.\n\n
          18. You will not enter into any commitments or dealings on behalf of the Company for which you have no express authority, nor alter or be a party to any alteration of any principles or policies of the Company or exceed the authority or discretion vested in you without the previous sanction of the Company.\n\n
          19. You shall perform your duties with diligence, devotion

          Sincerely,  
          
          #Designation# 
          
          #COMPANY_NAME#
          
        `.replace(/\n/g, '<br>');
        }
      }

      else if (this.popupName == 'Confirmation letter content with no change') {

      let contentbody = record.data.filter((elm: any) => elm.name == 'CONFIRMATION LETTER WITHOUT CHANGES');

        console.log(contentbody);

        this.employeeApplicationcontentBodyFromBackend = contentbody;
        let contentbodytemlate = contentbody[0]?.content;
        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
          // this.letterContentBody = contentbodytemlate;
          let decodedContent = this.decodeHtml(contentbodytemlate);
          this.letterContentBody = decodedContent.replace(/\n/g, '<br>');

        } else {
          
          this.employeeApplicationcontentBodyFromFrontEnd = "CONFIRMATION LETTER WITHOUT CHANGES"
          this.letterContentsubject = "#EMPLOYEE_NAME# Confirmation Letter";
          this.letterContentBody = `
         Ref.: SIL/HR/09\n
        Date: \n
To                                                                                            
Mr. #EMPLOYEE_NAME#\n

#Address#\n

Subject: Letter of Confirmation\n

Dear #EMPLOYEE_NAME#, \n
Further to your appointment letter dated on #Date#. We are pleased to inform you that your services with Sellowrap Industries Limited have been confirmed with effect from #Date# as ‘#Designation# - #Department#’ in Band ‘#Band#’.\n

You will be governed by the service rules and regulations of the company that are already in force and as may be issued from time to time.\n

Other terms and conditions as embodied in the appointment letter and policy manual will remain unchanged.\n

#COMPANY_NAME# congratulates you as on your confirmation and wishes you well in your position.\n

In token of your acceptance of the above terms and conditions, please sign and return the duplicate copy of this letter.\n

Yours truly,\n

For’ Sellowrap Industries Limited\n

Authorised Signatory\n
   TERMS ACCEPTED\n

        `.replace(/\n/g, '<br>');
        }
      }
      else if (this.popupName == 'Confirmation letter content with change') {

         let contentbody = record.data.filter((elm: any) => elm.name == 'CONFIRMATION LETTER WITH CHANGES');
      
        console.log(contentbody);

        this.employeeApplicationcontentBodyFromBackend = contentbody;
        let contentbodytemlate = contentbody[0]?.content;
        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
          // this.letterContentBody = contentbodytemlate;
          let decodedContent = this.decodeHtml(contentbodytemlate);
          this.letterContentBody = decodedContent.replace(/\n/g, '<br>');

        } else {
          this.employeeApplicationcontentBodyFromFrontEnd = "CONFIRMATION LETTER WITH CHANGES"
          this.letterContentsubject = "#EMPLOYEE_NAME# Confirmation Letter";
          this.letterContentBody = `
         Ref.: SIL/HR/09\n
        Date: \n
To Mr. #EMPLOYEE_NAME#\n
#Address#\n

Subject: Letter of Confirmation\n

Dear #EMPLOYEE_NAME#, \n

Further to your appointment letter dated on #Date#. We are pleased to inform you that your services with Sellowrap Industries Limited have been confirmed with effect from #Date# as ‘#Designation# - #Department#’ in Band ‘#Band#’.\n

You will be governed by the service rules and regulations of the company that are already in force and as may be issued from time to time.\n

Other terms and conditions as embodied in the appointment letter and policy manual will remain unchanged.\n

#COMPANY_NAME# congratulates you as on your confirmation and wishes you well in your position.\n

In token of your acceptance of the above terms and conditions, please sign and return the duplicate copy of this letter.\n

Yours truly,\n

For’ Sellowrap Industries Limited\n

Authorised Signatory\n
   TERMS ACCEPTED\n

        `.replace(/\n/g, '<br>');
        }
      }
      else if (this.popupName == 'Extention of probation content') {

       let contentbody = record.data.filter((elm: any) => elm.name == 'EXTENSION PROBATION');
       
        console.log(contentbody);

        this.employeeApplicationcontentBodyFromBackend = contentbody;
        let contentbodytemlate = contentbody[0]?.content;
        if (contentbody.length > 0) {
          this.letterContentsubject = contentbody[0]?.title;
          // this.employeeApplicationEmailBody = this.employeeApplicationEmailBodyFromBAckend;
          // this.letterContentBody = contentbodytemlate;
          let decodedContent = this.decodeHtml(contentbodytemlate);
          this.letterContentBody = decodedContent.replace(/\n/g, '<br>');

        } else {
          
          this.employeeApplicationcontentBodyFromFrontEnd = "EXTENSION PROBATION"
          this.letterContentsubject = "#EMPLOYEE_NAME# Confirmation Letter";
          this.letterContentBody = `
      Date: #Date# \n
      
      To, #EMPLOYEE_NAME# \n#Address# \n

      Subject: Extension of Probation Period \n

      Dear #EMPLOYEE_NAME#, \n
      
      We would like to inform you that your probation period at #COMPANY_NAME#, which was initially set to end on #dateOfConfirmation#, has been extended. The new probation end date will be . \nThis extension has been decided to provide you with additional time to meet the performance expectations required for confirmation in your role as #Designation#. During this period, you are expected to continue demonstrating progress in your responsibilities and alignment with company standards. \n
      
      If you have any questions regarding this extension, please feel free to reach out to the HR department\n
      
      Best Regards,\n
      
      #EMPLOYEE_NAME# \n
      
      #Designation# \n
      
      #COMPANY_NAME#

      `.replace(/\n/g, '<br>');
        }
      }
    })


  }

  ngAfterViewInit() {
    // Delay to ensure the HTML has been rendered

    setTimeout(() => {
      const linkElement = this.el.nativeElement.querySelector('#applicationFormLink');
      if (linkElement) {
        this.renderer.listen(linkElement, 'click', () => this.onClickOnemployeeFrom());
      }
    }, 0);
  }

  onClickOnemployeeFrom() {
    console.log("Click event triggered");
    this.router.navigate(['elcmfrom', { id: this.loggedInUserCompanyID }]);
  }
  onClickCloseInvitation() {
    // let data = {
    //   employeeApplicationEmailBody: this.employeeApplicationEmailBody,
    //   invitationEmailSubject: this.invitationEmailSubject
    // }
    // this.dialogRef.close(data);
    this.dialogRef.close();
  }
  onClickSaveInvitation() {

  }

  openConfirmationDialog(message: string) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close();
    });

  }
  openErrorDialog(errorMessage: string) {
    const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: errorMessage,
        btn2: 'OK',
        btn2BgColor: 'red', // Red color for errors
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: true
      }
    });

    errorDialogRef.afterClosed().subscribe(() => {
      console.log('Error dialog closed'); // Optional: Handle post-close actions
    });

    return errorDialogRef;
  }



  saveMaildata() {
    this.isEditing = !this.isEditing;


    // Reusable function to show error dialogs


    // Optimized validation checks
    if (!this.employeeApplicationEmailBody?.trim()) {
      this.openErrorDialog('Email body is required');
      return;
    }

    if (!this.invitationEmailSubject?.trim()) {
      this.openErrorDialog('Email subject is required');
      return;
    }


    if (this.subjectClick === '') {
      this.openConfirmationDialog("Email Template Updated Successfully");

      return;
    }
    console.log(this.employeeApplicationEmailBodyFromBAckend[0]?.name);

    let formData = {
      "body": this.employeeApplicationEmailBody,
      "isEnable": true,
      "name": this.employeeApplicationEmailBodyFromBAckend[0]?.name,
      "subject": this.emplyeeName + this.invitationEmailSubject,


    }
    if (this.employeeApplicationcontentBodyFromBackend?.length == 0) {
      this.httpService.callPostService(`${this.config.emailtempletFromForEmployee}`, formData).subscribe(
        (data: any) => {
          console.log(data);

          if (data) {
            // Success popup
            this.openConfirmationDialog(data.message);
          }
        },
        (error: any) => {

         
          this.openErrorDialog(error.message)
        }
      );
    } else {

      this.httpService.callPostService(`${this.config.emailtempletUpdateFormForEmployee}`, formData).subscribe(
        (data: any) => {
          console.log(data);

          if (data) {
            // Success popup
            this.openConfirmationDialog(data.message);
          }
        },
        (error: any) => {

          this.openErrorDialog(error.message)
        }
      );
    }
  }


  validateEmailFields() {

    let contentBodyTemplate = this.decodeHtml(this.letterContentBody);
    let letterContentBody = this.htmlToPlainText(contentBodyTemplate);

    let contentsubject = this.decodeHtml(this.letterContentsubject);
    let subject = this.htmlToPlainText(contentsubject);
    const validations = [
      { field: letterContentBody.trim(), message: 'Email body is required' },
      { field: subject.trim(), message: 'Email subject is required' }
    ];

    for (const { field, message } of validations) {
      if (!field) {
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: message,
            btn2: 'OK',
            btn2BgColor: 'red',
            showSuccessIcon: false,
            showSuccessMessage: false,
          }
        });
        return false;
      }
    }
    return true;
  }

  htmlToPlainText(html: string): string {
    return html
      .replace(/<div>/g, '\n')   // Convert <div> to new line
      .replace(/<\/div>/g, '')   // Remove closing </div>
      .replace(/<br\s*\/?>/g, '\n') // Convert <br> to new line
      .replace(/&nbsp;/g, ' ')  // Convert &nbsp; to space
      .replace(/<\/?[^>]+(>|$)/g, ''); // Remove all remaining HTML tags
  }

  // saveMailContentdata() {
  //   if (!this.validateEmailFields()) return;
  //   if (this.subjectClick === '') {

  //     this.openConfirmationDialog("Email Template Updated Successfully")
  //     return;
  //   }

  //   let contentbodytemlate = this.decodeHtml(this.letterContentBody);
  //   // Step 2: Convert HTML to plain text
  //   let letterContentBody = this.htmlToPlainText(contentbodytemlate);
  //   let formData = {
  //     "id": this.employeeApplicationcontentBodyFromBackend[0]?.id,
  //     "name": this.employeeApplicationcontentBodyFromBackend[0]?.name,
  //     "title": this.letterContentsubject,
  //     "content": letterContentBody,
  //     "companyId": this.loggedInUserCompanyID

  //   }

  //   console.log(contentbodytemlate);
  //   console.log(formData);


  //   this.httpService.callPostService(`${this.config.addOrUpdateLatter}`, formData).subscribe(
  //     (data: any) => {
  //       console.log(data);

  //       if (data) {
  //         // Success popup
  //         this.openConfirmationDialog(data.message);
  //       }
  //     },
  //     (error: any) => {

  //       this.openErrorDialog(error.message)
  //     }
  //   );

  // }

  isSubmitting = false; // Prevent multiple submissions

  saveMailContentdata() {
    if (this.isSubmitting) return; // Prevent duplicate API calls

    if (!this.validateEmailFields()) return;

    // if (this.subjectClick === '') {
    //   this.showPopup("Email Template Updated Successfully", 'green', true);
    //   return;
    // }

    let contentBodyTemplate = this.decodeHtml(this.letterContentBody);
    let letterContentBody = this.htmlToPlainText(contentBodyTemplate);

    let formData = {
      "id":this.employeeApplicationcontentBodyFromBackend[0]?.id || null,
      "name": this.employeeApplicationcontentBodyFromBackend[0]?.name || this.employeeApplicationcontentBodyFromFrontEnd,
      "title": this.letterContentsubject,
      "content": letterContentBody,
      "companyId": this.loggedInUserCompanyID
    };

    console.log(contentBodyTemplate);
    console.log(formData);

    this.isSubmitting = true; // Set flag to prevent multiple calls

    this.httpService.callPostService(`${this.config.addOrUpdateLatter}`, formData).subscribe(
      (data: any) => {
        console.log(data);
        this.showPopup(data.message, 'success', true);
        this.isSubmitting = false; // Reset flag
      },
      (error: any) => {
        this.showPopup(error.message || "An error occurred.", 'danger', false);
        this.isSubmitting = false; // Reset flag
      }
    );
  }

  // ✅ Reusable popup function
  showPopup(message: string, color: string, isSuccess: boolean) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: color,
        showSuccessIcon: isSuccess,
        showSuccessMessage: false,
        showCloseIcon: !isSuccess
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (isSuccess) this.dialogRef.close(); // Close only on success
    });
  }

}
